import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Picture\UpdatePictureFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/UpdatePictureFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
const UpdatePictureFromDossierGalleryController = (args: { dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePictureFromDossierGalleryController.url(args, options),
    method: 'put',
})

UpdatePictureFromDossierGalleryController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/gallery/picture/{picture_id}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\Picture\UpdatePictureFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/UpdatePictureFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
UpdatePictureFromDossierGalleryController.url = (args: { dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            picture_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        picture_id: typeof args.picture_id === 'object'
        ? args.picture_id.id
        : args.picture_id,
    }

    return UpdatePictureFromDossierGalleryController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{picture_id}', parsedArgs.picture_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Picture\UpdatePictureFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/UpdatePictureFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
UpdatePictureFromDossierGalleryController.put = (args: { dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePictureFromDossierGalleryController.url(args, options),
    method: 'put',
})

export default UpdatePictureFromDossierGalleryController